export function delay(timeInSeconds = 0) {
    return new Promise(function (resolve) {
        setTimeout(resolve, timeInSeconds * 1000)
    })
}
